"use strict";

var _slicedToArray = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesAllSelectedOptions = void 0;
/**
 *
 *
 * @export
 * @param {SelectedOptions} from
 * @param {SelectedOptions} to
 * @param {string[]} ignore [[]=[]]
 * @returns {boolean}
 */

function matchesAllSelectedOptions(from, to) {
  var ignore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return Object.entries(from).every(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return ignore.includes(name) || to[name] === value;
  });
}

exports.matchesAllSelectedOptions = matchesAllSelectedOptions;